import { UpsertEventMeetingButton, FullEventMeetingButton, EventMeetingVideoType } from '@front-app/services/EventsApi/EventModel';

export function checkIfEventManagementDataOnlineMeetingIsEmpty(onlineLocation: UpsertEventMeetingButton): UpsertEventMeetingButton {
	if (onlineLocation.videoUrl && onlineLocation.videoButtonText && onlineLocation.videoButtonColor) {
		return onlineLocation;
	}
	return {
		isEnabled: false,
		videoUrl: 'https://',
		videoButtonText: 'Online Meeting',
		videoButtonColor: '#0a60a6',
	};
}

export function checkIfFullEventOnlineMeetingIsEmpty(onlineLocation: FullEventMeetingButton): FullEventMeetingButton {
	if (onlineLocation.videoUrl && onlineLocation.videoButtonText && onlineLocation.videoButtonColor) {
		return onlineLocation;
	}
	return {
		videoType: EventMeetingVideoType.NONE,
		videoUrl: 'https://',
		videoButtonText: 'Online Meeting',
		videoButtonColor: '#0a60a6',
	};
}
